import type { PayHubCashierContractsPendingWithdrawalResponse } from './APIModels';

export interface WithdrawalRejectRequestResponse {
  success_amount: number;
  fail_amount: number;
}

export interface PartialReverseInfo {
  pendingWithdrawals: PayHubCashierContractsPendingWithdrawalResponse[];
  isPartialReverseEnabled: boolean;
  preselectedOption: number;
  precision?: number;
}

export interface WithdrawalRejectState extends PartialReverseInfo {
  amount?: number;
  currency?: string;
  isOpened: boolean;
  closeTrigger: number;
  isFetching: boolean;
  response?: WithdrawalRejectRequestResponse;
}

export enum WithdrawalRejectRequestStatus {
  success,
  failed,
}
